import * as React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';

import SelectStorySnippetsPreviewGrid from './components/select-story-snippets-preview-grid/SelectStorySnippetsPreviewGrid';
import SelectStorySnippetsGroupedView from './components/select-story-snippets-grouped-view/SelectStorySnippetsGroupedView';

import {
  changeStorySnippetPreviewAction,
  toggleStorySnippetAction
} from '../../redux/actions';

import { getGroupedStorySnippets } from '../../utils/grouping';

import { State } from 'types';
import { GroupedByDate, StorySnippet } from '../../types';

import './select-story-snippets-grid.scss';

interface StateProps {
  snippets: null | GroupedByDate<StorySnippet>,
  selectedSnippets: Array<string>,
  previewSnippetCode: null | string
}

interface DispatchProps {
  dispatchOnToggleSnippet: (code: string) => void,
  dispatchOnRequestSnippetPreview: (code: string) => void
}

type Props = StateProps & DispatchProps;

const SelectStorySnippetsGrid = ({
  snippets,
  selectedSnippets,
  previewSnippetCode,
  dispatchOnToggleSnippet,
  dispatchOnRequestSnippetPreview
}: Props): JSX.Element => (
  <div
    className={classnames('select-story-snippets-grid', {
      'select-story-snippets-grid--with-preview': previewSnippetCode !== null
    })}
  >
    {previewSnippetCode !== null && snippets !== null ? (
      <SelectStorySnippetsPreviewGrid
        snippets={snippets}
        selectedSnippets={selectedSnippets}
        previewSnippetCode={previewSnippetCode}
        onToggleSnippet={dispatchOnToggleSnippet}
        onRequestSnippetPreview={dispatchOnRequestSnippetPreview}
      />
    ) : null}
    {previewSnippetCode === null && snippets !== null ? (
      <SelectStorySnippetsGroupedView
        snippets={snippets}
        selectedSnippets={selectedSnippets}
        previewSnippetCode={previewSnippetCode}
        onToggleSnippet={dispatchOnToggleSnippet}
        onRequestSnippetPreview={dispatchOnRequestSnippetPreview}
      />
    ) : null}
  </div>
);

const mapStateToProps = ({ selectStorySnippets }: State): StateProps => ({
  snippets: selectStorySnippets.storySnippets === null
    ? null
    : getGroupedStorySnippets(selectStorySnippets.storySnippets, new Date()),
  selectedSnippets: selectStorySnippets.selectedStorySnippets,
  previewSnippetCode: selectStorySnippets.storySnippetPreview
});

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchOnToggleSnippet: code => dispatch(toggleStorySnippetAction(code)),
  dispatchOnRequestSnippetPreview: code => dispatch(changeStorySnippetPreviewAction(code))
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectStorySnippetsGrid);
